import { IGenerateReportJsonResponse } from "../../../../api/types/reports/IGenerateReportJsonResponse";
import { IEditReportPriceEntry } from "../../../../api/types/reports/IEditReportPricesParams";
import { getOperatorNamesFromStats, resolveOperatorCell } from "./resolveOperatorCell";

export type PriceEditDraft = Record<string, Record<string, string>>;

export function resolveEditPayloadNights(appliedNightKeys: string[]): number[] {
  if (appliedNightKeys.length === 0) {
    return [0];
  }

  return appliedNightKeys.map((night) => Number(night));
}

export function buildPriceEditDraft(
  data: IGenerateReportJsonResponse,
  appliedNightKeys: string[],
  availableNights: string[],
): PriceEditDraft {
  const operatorNames = getOperatorNamesFromStats(data.stats);
  const draft: PriceEditDraft = {};

  for (const row of data.stats) {
    draft[row.date] = {};
    for (const operatorName of operatorNames) {
      const cell = resolveOperatorCell(
        row.operators[operatorName],
        appliedNightKeys,
        availableNights,
      );
      draft[row.date][operatorName] =
        cell?.price != null ? String(cell.price) : "";
    }
  }

  return draft;
}

export function buildEmptyPriceEditDraft(
  data: IGenerateReportJsonResponse,
): PriceEditDraft {
  const operatorNames = getOperatorNamesFromStats(data.stats);
  const draft: PriceEditDraft = {};

  for (const row of data.stats) {
    draft[row.date] = {};
    for (const operatorName of operatorNames) {
      draft[row.date][operatorName] = "";
    }
  }

  return draft;
}

export function buildPriceEditPayload(
  draft: PriceEditDraft,
  data: IGenerateReportJsonResponse,
  appliedNightKeys: string[],
): IEditReportPriceEntry[] {
  const operatorNames = getOperatorNamesFromStats(data.stats);
  const nights = resolveEditPayloadNights(appliedNightKeys);

  return data.stats.map((row) => {
    const operators: Record<string, number> = {};

    for (const operatorName of operatorNames) {
      const rawValue = draft[row.date]?.[operatorName] ?? "";
      const trimmedValue = rawValue.trim();
      if (trimmedValue === "") {
        continue;
      }

      const price = Number(trimmedValue);
      if (Number.isNaN(price)) {
        continue;
      }

      const operatorId = row.operators[operatorName]?.id;
      if (operatorId === undefined || operatorId === null) {
        continue;
      }

      operators[String(operatorId)] = price;
    }

    return {
      date: row.date,
      nights,
      operators,
    };
  });
}
